<template>
  <div
    class="audiogroup"
    :class="{ 'asset-drag-over': isAudioAssetDraggedOver }"
    @dragenter="dragEnter = true"
    @dragleave="dragEnter = false"
    @dragover.prevent
  >
    <vddl-list
      class="audio-asset-list"
      :list="audioAssets"
      :drop="onDropped"
      :allowed-types="allowedTypes"
      :disable-if="!canEdit"
    >
      <audio-asset-collection-item
        v-for="(asset, index) in assetRefs"
        :id="id"
        :key="asset.id"
        :list="assetRefs"
        :item="audioAssets[index]"
        :draggable="asset"
        :index="index"
        :wrapper="assetRefs"
        :type="type"
        :disable-if="!canEdit"
        :move-action="moveAction"
        :delete-action="deleteAction"
      />
    </vddl-list>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { useProtect } from '@/composables/useProtect.js';
import { SYS_PERMISSIONS, DRAG_TYPE } from '@/constants.js';
import AudioAssetCollectionItem from './AudioAssetCollectionItem.vue';

export default {
  components: {
    AudioAssetCollectionItem,
  },

  props: {
    id: {
      type: String,
      default: null,
    },
    assetRefs: {
      type: Array,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    listType: {
      type: String,
      default: null,
    },
    allowedTypes: {
      type: Array,
      default: null,
    },
    moveAction: {
      type: Function,
      default: () => {},
    },
    deleteAction: {
      type: Function,
      default: () => {},
    },
  },

  setup() {
    const { hasPermission: canEdit } = useProtect({
      permissions: [SYS_PERMISSIONS.SYS_PROJECTS_EDIT],
      roles: ['editor'],
    });

    return {
      canEdit,
    };
  },

  data() {
    return {
      dragEnter: false,
    };
  },

  computed: {
    ...mapGetters('application/drag', ['getItems']),
    ...mapGetters('project/data/assets', ['getNodes']),

    /**
     * Return whether there is an audioAsset currently dragged over the element
     * @returns {Boolean}
     */
    isAudioAssetDraggedOver() {
      const { type } = this.getItems;
      return (
        this.dragEnter &&
        (type === DRAG_TYPE.ASSET || type === DRAG_TYPE.ELEMENT_ASSET)
      );
    },

    /**
     * Returns the asset nodes of the element
     */
    audioAssets() {
      const ids = this.assetRefs.map(a => a.asset);
      return this.getNodes(ids);
    },
  },

  methods: {
    ...mapActions('application/drag', ['setTarget']),

    onDropped(event) {
      this.setTarget({
        value: {
          type: this.listType,
          id: this.id,
          index: event.index,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.audiogroup {
  padding-bottom: 8px;
  .vddl-placeholder {
    background: #fff;
    position: relative;
    &:after {
      content: '';
      position: absolute;
      z-index: 1000;
      right: 0;
      bottom: 0;
      left: 0;
      height: 2px;
      background: #fff;
    }
  }

  .vddl-dragging-source {
    display: none;
  }
}
</style>
